module.exports = __webpack_public_path__ + "img/D2-a.e45e9c19.jpg";